// @core/api/endpoints/team/update_team_user_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamUserSettingsRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update team user settings
 * Updates an existing team user settings with the provided data. Returns the updated resource.
 */
export async function UpdateTeamUserSettings(
  team_id: string,
  data: UpdateTeamUserSettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/user`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
